import { render, staticRenderFns } from "./AppDealBatch.vue?vue&type=template&id=1be0ee10&scoped=true"
import script from "./AppDealBatch.vue?vue&type=script&lang=js"
export * from "./AppDealBatch.vue?vue&type=script&lang=js"
import style0 from "./AppDealBatch.vue?vue&type=style&index=0&id=1be0ee10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0ee10",
  null
  
)

export default component.exports